import React from "react";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import HttpFetchStatus from "../../enums/api/http-fetch-status";
import CustomAlert from "../Feedback/CustomAlert";

const GeneralLoaderWrapper: React.FC<{
    getStatus: HttpFetchStatus;
    children: React.ReactNode;
    loadingMessage?: string;
    dataLoaded: boolean;
    failedToLoadMessage: string;
    failedToLoadDetails?: string | undefined;
}> = ({ getStatus, children, loadingMessage, dataLoaded, failedToLoadMessage, failedToLoadDetails = undefined }) => {
    if (getStatus === HttpFetchStatus.Loading || getStatus === HttpFetchStatus.Idle) {
      return (
        <Typography sx={{ alignItems: "center", display: "flex" }}>
          <CircularProgress
            size={24}
            sx={(theme) => ({
              color: theme.palette.primary.main,
              mr: 2,
            })}
          />
          {loadingMessage}...
        </Typography>
      );
    } else if (getStatus === HttpFetchStatus.Failed || dataLoaded === false) {
      if (failedToLoadDetails == null) {
        return <Alert severity="error">{failedToLoadMessage}</Alert>;
      } else {
        return <CustomAlert severity="error" header={failedToLoadMessage} textMessages={[failedToLoadDetails]} />;
      }
    }

    return <React.Fragment>{children}</React.Fragment>;
};

export default GeneralLoaderWrapper;
